<template>
  <div class="password-reset-mail-sent-page">
    <sub-header-section :pageTitle="$tc('PasswordResetPage.subTitle')" backLink="/password-reset" />

    <password-reset-mail-sent-pane class="password-reset-mail-sent-page__content" />

    <action-buttons-section
      scrollTargetSelector=".password-reset-mail-sent-page__content"
      :visible="true"
    >
      <atom-link-button
        :linkText="$tc('PasswordResetPage.MailSentPage.backBtnText')"
        :url="loginUrl"
        :isOpenAsBlank="false"
        colorType="secondary"
      />
    </action-buttons-section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SubHeaderSection from '@/components/common/Header/SubHeaderSection.vue'
import ActionButtonsSection from '@/components/common/form/ActionButtonsSection.vue'
import AtomLinkButton from '@/components/atoms/AtomLinkButton.vue'
import PasswordResetMailSentPane from '@/components/PasswordResetPage/PasswordResetMailSentPane.vue'

/**
 * パスワードリセット メール送信完了 ページ
 */
export default defineComponent({
  name: 'PasswordResetMailSentPage',
  components: {
    SubHeaderSection,
    ActionButtonsSection,
    AtomLinkButton,
    PasswordResetMailSentPane,
  },
  setup() {
    const loginUrl = `${process.env.VUE_APP_BROWSER_CAN_REDIRECT_TO_APP_BASE_URL}#/login`

    return {
      loginUrl,
    }
  },
})
</script>

<style lang="scss">
.password-reset-mail-sent-page {
  .action-buttons-section {
    bottom: 0;

    &__inner {
      padding-bottom: calc(16px + #{env(safe-area-inset-bottom)});
    }
  }
}
</style>
